import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

type SectionHeaderProps = {
    title: string;
    subtitle?: string;
    action?: {
        label: string;
        to: string;
    };
    className?: string;
};

/**
 * Simple, reusable section header used across the Home Dashboard rails.
 * Left: title + optional subtitle. Right: optional "See all" link.
 */
export function SectionHeader({
    title,
    subtitle,
    action,
    className,
}: SectionHeaderProps) {
    return (
        <div
            className={cn(
                "mb-4 flex items-end justify-between gap-4",
                className,
            )}
        >
            <div>
                <h2 className="tsgo-h2">{title}</h2>
                {subtitle ? (
                    <p className="mt-0.5 text-sm text-muted-foreground">
                        {subtitle}
                    </p>
                ) : null}
            </div>
            {action ? (
                <Link
                    to={action.to}
                    className="inline-flex shrink-0 items-center gap-1 text-sm font-semibold text-brand hover:underline"
                >
                    {action.label}
                    <ArrowRight className="h-4 w-4" />
                </Link>
            ) : null}
        </div>
    );
}

export default SectionHeader;
